import { Validator } from '@vista-digital/validator';
import { ButtonSize } from '../../../../subcomponents';
export const defaultUpdateMemberCredentialPromptFormConfigBase = {
    actionButton: { size: ButtonSize.Small }
};
export const defaultUpdatePasswordMemberCredentialPromptFormConfig = Object.assign(Object.assign({}, defaultUpdateMemberCredentialPromptFormConfigBase), { maskedPasswordLength: 10 });
const updateMemberCredentialPromptFormConfigValidatorSchema = {
    actionButton: Validator.object({
        size: Validator.oneOf(Object.values(ButtonSize))
    })
};
export const updateMemberCredentialPromptFormConfigBaseValidator = Validator.object(updateMemberCredentialPromptFormConfigValidatorSchema);
export const updatePasswordMemberCredentialFormConfigValidator = Validator.object(Object.assign(Object.assign({}, updateMemberCredentialPromptFormConfigValidatorSchema), { maskedPasswordLength: Validator.number({ min: 1 }) }));
//# sourceMappingURL=config.js.map